import React, { useMemo } from 'react'
import TextScanEvent from './scanHistoryComponents/TextScanEvent';
import TextEvent from './scanHistoryComponents/TextEvent';
import { MachineEvent, TextEventProps } from '../../../ts/MachineEvent';
import { Machine } from '../../../ts/Connections';
import { Cargo } from '../../../ts/Cargo';
import ScanSkeleton from './scanHistoryComponents/ScanSkeleton';
import { useTranslation } from 'react-i18next';
import ScanHistoryList, { TimelineItem } from './ScanHistoryList';

interface ScanHistoryMobileProps {
    selectedScanIndex: number;
    setSelectedScanIndex: (index: number) => void;
    cargoResponses: Cargo[];
    machineEvents: MachineEvent[];
    setOpenScanDetails: (open: boolean) => void;
    machine: Machine;
    open: boolean;
    onEndReached?: () => void;
    onStartReached?: () => void;
    onAtTopChange?: (atTop: boolean) => void;
    loadingOlder?: boolean;
    listHeight?: string | number;
    refreshEnabled?: boolean;
}

function ScanHistoryMobile(props: ScanHistoryMobileProps) {
    const { selectedScanIndex, setSelectedScanIndex, cargoResponses, machineEvents, setOpenScanDetails, machine, open,
        onEndReached, onStartReached, onAtTopChange, loadingOlder, listHeight, refreshEnabled } = props;
    const { t } = useTranslation();

    // Create a combined timeline of machine events and scan events (and sort by timestamp)
    const timelineEvents = useMemo(() => {
        return [...machineEvents, ...cargoResponses].sort((a, b) => b.timeStamp.getTime() - a.timeStamp.getTime());
    }, [machineEvents, cargoResponses]);

    const handleListItemClick = (
        _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedScanIndex(index);
    };

    const openDetailsModal = function () {
        setOpenScanDetails(true);
    }

    const renderRow = (index: number, historyEvent: TimelineItem) => {
        if (historyEvent instanceof Cargo) {
            const cargoIndex = cargoResponses.indexOf(historyEvent);
            const resolvedIndex = cargoIndex >= 0 ? cargoIndex : index;
            return (
                <TextScanEvent cargoResponse={historyEvent} scanFailure={historyEvent.dimensionCode === "0" ? false : true}
                    cargoResponseIndex={resolvedIndex} handleListItemClick={handleListItemClick} selectedScanIndex={selectedScanIndex}
                    openDetailsModal={openDetailsModal} machine={machine} open={open} />
            )
        }
        if (historyEvent instanceof TextEventProps) {
            return <TextEvent {...historyEvent} />
        }
        if (historyEvent instanceof MachineEvent && !historyEvent.complete) {
            return <ScanSkeleton />
        }
        return <div>{t('control.eventHistory.unknownItem')}</div>
    }

    return (
        <ScanHistoryList
            data={timelineEvents}
            itemContent={renderRow}
            onEndReached={onEndReached}
            onStartReached={onStartReached}
            onAtTopChange={onAtTopChange}
            loadingOlder={loadingOlder}
            listHeight={listHeight}
            refreshEnabled={refreshEnabled}
        />
    )
}

export default React.memo(ScanHistoryMobile);